import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/hooks/useSeo";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  useSeo({ title: "Cambiar contraseña", description: "Define tu contraseña personal.", path: "/portal/password", noindex: true });
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) return toast.error("Mínimo 8 caracteres");
    if (form.new_password !== form.confirm) return toast.error("Las contraseñas no coinciden");
    setBusy(true);
    try {
      await api.post("/portal/change-password", { current_password: form.current_password, new_password: form.new_password });
      const { data } = await api.get("/auth/me");
      if (setUser) setUser(data);
      toast.success("Contraseña actualizada");
      navigate("/portal", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "No se pudo cambiar la contraseña");
    } finally {
      setBusy(false);
    }
  };

  const field = (label, key, testId, placeholder) => (
    <label className="block">
      <span className="text-[10px] uppercase tracking-widest text-neutral-500 font-mono">{label}</span>
      <input type="password" required value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} placeholder={placeholder} className="mt-1 w-full bg-transparent border border-white/15 rounded-lg px-3 py-2.5 text-sm text-white focus:border-[#FFBF57] outline-none" data-testid={testId} />
    </label>
  );

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex items-center justify-center p-6" data-testid="change-password-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl border border-white/10 bg-[#111112] p-8">
        <div className="w-11 h-11 rounded-full bg-[#FFBF57]/10 border border-[#FFBF57]/30 flex items-center justify-center text-[#FFBF57]"><KeyRound size={18} /></div>
        <p className="eyebrow mt-6">Primer acceso</p>
        <h1 className="font-display text-3xl mt-3">Crea tu contraseña personal</h1>
        <p className="text-neutral-400 text-sm mt-3 leading-relaxed">Por seguridad, la contraseña inicial que te compartió tu asesor debe reemplazarse antes de ver tu información financiera.</p>
        <div className="mt-8 space-y-4">
          {field("Contraseña actual (inicial)", "current_password", "cp-current", "expansion2026")}
          {field("Nueva contraseña", "new_password", "cp-new", "Mínimo 8 caracteres")}
          {field("Confirmar nueva contraseña", "confirm", "cp-confirm", "Repite la contraseña")}
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full justify-center mt-8" data-testid="cp-submit">{busy ? "Guardando…" : "Guardar y continuar"}</button>
        <div className="mt-6 flex items-start gap-3 text-xs text-neutral-500 leading-relaxed"><ShieldCheck size={16} strokeWidth={1.5} className="mt-0.5 text-[#FFBF57]" /><span>Tu contraseña se almacena cifrada. Nadie del equipo Rubí puede verla.</span></div>
      </form>
    </div>
  );
}
